<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <Container use-full-width>
      <Breadcrumbs />
    </Container>

    <ContentSection spacing="none">
      <div class="grid lg:grid-cols-2">
        <!-- Image -->
        <AppImage :src="page.image" class="aspect-video size-full object-cover" :class="{ 'lg:order-2': page.image_position?.value === 'right' }" />
        <!-- Text -->
        <div
          class="
            flex flex-col justify-center px-container py-14
            2xl:px-container-desktop
            3xl:py-32
            lg:py-20
            md:px-container-desktop-half
          "
          :class="[
            page.image_position?.value === 'right'
              ? `lg:pl-container-desktop-half lg:pr-14 xl:pl-container-desktop xl:pr-container-desktop-half`
              : `lg:pl-14 lg:pr-container-desktop-half xl:pl-container-desktop-half xl:pr-container-desktop`,
            {
              'bg-gradient-01 text-white': page.background_color?.value === 'gradient-01',
              'bg-grey-100': page.background_color?.value === 'grey',
              'bg-white': page.background_color?.value === 'white',
            },
          ]"
        >
          <div class="max-lg:px-container">
            <HeadingGroup
              v-if="page.heading"
              :heading="page.heading"
              :sub-heading="page.sub_heading"
              class="typo-h3"
            />
            <div
              v-if="page.text"
              class="mt-6 max-w-text typo-lead"
              v-html="page.text"
            />
            <AppButton
              v-if="page.link"
              :inverted="page.background_color?.value === 'gradient-01'"
              class="mt-6 max-sm:w-full"
              :to="page.link"
            >
              {{ page.link_text }}
            </AppButton>
          </div>
        </div>
      </div>
    </ContentSection>

    <LoaderComponents
      v-editor-target="'main_components'"
      :components="page.main_components"
    />
  </div>
</template>

<script setup lang="ts">
import type { BlueprintCleaningMethodFragment } from '#gql'

defineProps<{
  page: Enforce<BlueprintCleaningMethodFragment>
}>()

provide('isHero', true)
</script>
